<template>
  <div>
    <el-switch
      v-if="IsAllowedToView"
      style="display: block"
      v-model="value"
      active-color="#ff4949"
      inactive-color="#13ce66"
      active-text="Blocqueadas"
      inactive-text="Sin Blocquear"
      @change="handleChange"
    >
    </el-switch>
  </div>
</template>

<script>
export default {
  name: "BlockUnblockSomeRequestTypes",
  props: {
    ClientCode: {
      type: String,
      default: "",
      required: false
    },
    IsItBlocked: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      value: false
    };
  },
  created() {
    console.log("Created called", this.IsItBlocked);
    this.value = this.IsItBlocked;
  },
  updated() {
    console.log("Updated called", this.IsItBlocked);
    this.value = this.IsItBlocked;
  },
  computed: {
    IsAllowedToView() {
      let ArrayPositions = [
        16, // CEO
        129 // GERENTE DE ADMINISTRACIÓN , FINANZAS Y RECURSOS HUMANOS
      ];
      return ArrayPositions.includes(this.currentUser.PositionID);
    }
  },
  methods: {
    handleChange(value) {
      console.log("Switch changed to: ", value);
      this.value = value;
      this.$emit("LockChanged", value);
    }
  },
  watch: {
    IsItBlocked(newVal) {
      console.log("Watch called", newVal);
      this.value = newVal;
    },
    ClientCode() {
      console.log("ClientCode changed");
      this.value = this.IsItBlocked;
    }
  }
};
</script>

<style lang="scss" scoped></style>
